import { render, staticRenderFns } from "./certificate-selector.vue?vue&type=template&id=3166578c&lang=pug&"
import script from "./certificate-selector.vue?vue&type=script&lang=ts&"
export * from "./certificate-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports